/** @param {boolean} active */
export function actionRowIconOnlySx(active) {
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'var(--app-radius-md)',
    width: '32px',
    minWidth: '32px',
    height: '32px',
    p: 0,
    backgroundColor: active ? 'var(--app-bg-panel)' : 'transparent',
    border: 'none',
    '&:hover': {
      backgroundColor: active ? 'var(--app-bg-panel)' : 'var(--app-bg-hover)',
    },
  }
}

/** @param {boolean} plain @param {boolean} active */
export function actionRowMainSx(plain, active) {
  const variantSx = plain
    ? {
        backgroundColor: 'transparent',
        border: 'none',
        '&:hover': { backgroundColor: 'var(--app-bg-hover, rgba(0, 0, 0, 0.04))' },
      }
    : active
      ? {
          backgroundColor: 'var(--app-bg-panel)',
          border: 'none',
          '&:hover': { backgroundColor: 'var(--app-bg-panel)' },
        }
      : {
          backgroundColor: 'transparent',
          border: 'none',
          '&:hover': { backgroundColor: 'var(--app-bg-hover)' },
        }

  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: 'var(--app-radius-md)',
    width: '100%',
    px: '12px',
    ...variantSx,
  }
}

export const actionRowLabelSx = { fontWeight: 600 }
